"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmonitorElement = exports.monitorElement = void 0;
var utils_1 = require("./utils");
var listenersWeakMap = new WeakMap();
var add = function (el, action, handler) {
    var _a, _b;
    if (!listenersWeakMap.has(el)) {
        listenersWeakMap.set(el, new Set());
    }
    if ((_a = listenersWeakMap.get(el)) === null || _a === void 0 ? void 0 : _a.has(action))
        return;
    (_b = listenersWeakMap.get(el)) === null || _b === void 0 ? void 0 : _b.add(action);
    el.addEventListener(action, handler, false);
};
var remove = function (el, action) {
    var listeners = listenersWeakMap.get(el) || new Set();
    if (action) {
        listeners.delete(action);
        el.removeEventListener(action, handler);
    }
    else {
        listeners.forEach(function (action) { return el.removeEventListener(action, handler); });
        listenersWeakMap.delete(el);
    }
};
var monitorElement = function (el) {
    var actions = el.__monitor_actions || [];
    actions.forEach(function (action) {
        add(el, action, handler);
    });
};
exports.monitorElement = monitorElement;
var unmonitorElement = function (el) {
    ;
    (el.__monitor_actions || []).forEach(function (action) {
        remove(el, action);
    });
};
exports.unmonitorElement = unmonitorElement;
function handler(event) {
    var _a, _b, _c, _d;
    try {
        var type = event.type;
        var currentTarget = event.currentTarget;
        var params = JSON.parse(((_a = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.dataset) === null || _a === void 0 ? void 0 : _a.monitor) || '{}')[type];
        var extra = JSON.parse(((_b = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.dataset) === null || _b === void 0 ? void 0 : _b.monitorExtra) || '{}');
        var data = __assign(__assign({}, params), { params: __assign(__assign({}, (params.params || {})), extra) });
        if (!((_c = currentTarget.__monitor) === null || _c === void 0 ? void 0 : _c.request)) {
            (0, utils_1.localLog)(data);
        }
        (_d = currentTarget.__monitor) === null || _d === void 0 ? void 0 : _d.request(data);
    }
    catch (e) {
        console.error(e);
    }
}
